import { Component } from 'react';
import { Container, Button, Row, Col, Form, FormGroup, Label, Input } from 'reactstrap';
import { AMS360SetupsModel, AMS360SetupsClient, ConversionServerModel, ConversionClient, ConversionServerClient } from '../../../client/ApiClient';
import { DataTable, DataRow, DataCell } from 'components/basic/DataTable';

interface AMS360SetupsCreateState {
    ndt: AMS360SetupsModel | null;
    serverList: ConversionServerModel[] | null;
}

class AMS360SetupsCreate extends Component<{}, AMS360SetupsCreateState> {
    private client: AMS360SetupsClient = new AMS360SetupsClient();
    private conversionServerClient: ConversionServerClient = new ConversionServerClient();

    constructor(props: {}) {
        super(props);
        this.state = {
            ndt: null,
            serverList: null,
        };
    }

    componentDidMount() {
        this.conversionServerClient.listSource()
            .then(result => {
                this.setState({ serverList: result });
            })
            .catch(err => { });
    }

    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            ndt: {
                ...prevState.ndt,
                [name]: value
            } as AMS360SetupsModel
        }));
    }

    submit = () => {
        this.client.aMS360Setups(this.state.ndt)
            .then(() => this.handleBackToList())
            .catch(err => {
                console.log(err)
            })
    }

    handleBackToList = () => {
        window.location.href = '/tools/ndt/epic';
    }

    clearForm = ()=>{
        this.setState({ndt: null})
    }

    isFormValid(): boolean {
        const ndt = this.state.ndt
        return ndt === null
            || ndt.sourceDatabaseName  === ''
            || ndt.sourceServerId === ''
            || ndt.targetDatabaseName === ''
            || ndt.targetServerId === ''
            || Object.keys(ndt).length !== 4
    }


    public render() {
        return (
            <Container className="mt-4">
                <Row className="mb-2">
                    <Col xs={8} md={9}><h4>Create New AMS360 Setup</h4></Col>
                    <Col xs={4} md={3}><Button color='secondary' className='submit-button-orange' onClick={this.handleBackToList}>Back to List</Button></Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={12} md={12}>
                        <Form>
                            <FormGroup row>
                                <Label for="serverInput" sm={3}>SQL Server to Copy From</Label>
                                <Col sm={6}>
                                    <Input
                                        id="serverInput"
                                        name="sourceServerId"
                                        type="select"
                                        value={this.state.ndt && this.state.ndt!.sourceServerId! || ''}
                                        onChange={e => this.handleChange(e)} >
                                        <option>Select Server</option>
                                        {this.state.serverList?.filter(s => s.amS360Setup).map(item => (
                                            <option key={item.id} value={item.id}>{item.serverInstanceName}</option>
                                        ))}
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="sourceDatabaseNameInput" sm={3}>SQL Database to Copy From</Label>
                                <Col sm={6}>
                                    <Input
                                        id="sourceDatabaseNameInput"
                                        name="sourceDatabaseName"
                                        type="text"
                                        value={this.state.ndt && this.state.ndt!.sourceDatabaseName || ''}
                                        onChange={e => this.handleChange(e)} >
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="serverInput" sm={3}>SQL Server to Copy To</Label>
                                <Col sm={6}>
                                    <Input
                                        id="serverInput"
                                        name="targetServerId"
                                        type="select"
                                        value={this.state.ndt && this.state.ndt!.targetServerId! || ''}
                                        onChange={e => this.handleChange(e)} >
                                        <option>Select Server</option>
                                        {this.state.serverList?.filter(s => s.amS360Setup).map(item => (
                                            <option key={item.id} value={item.id}>{item.serverInstanceName}</option>
                                        ))}
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="targetDatabaseNameInput" sm={3}>SQL Database to Copy To</Label>
                                <Col sm={6}>
                                    <Input
                                        id="targetDatabaseNameInput"
                                        name="targetDatabaseName"
                                        type="text"
                                        value={this.state.ndt && this.state.ndt!.targetDatabaseName || ''}
                                        onChange={e => this.handleChange(e)} >
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ offset: 3, size: 9 }}>
                                    <Button color="success" disabled={this.isFormValid()} onClick={e => { e.preventDefault(); this.submit(); }}>
                                        Submit
                                    </Button>
                                    {' '}
                                    <Button color="danger" onClick={e => { e.preventDefault(); this.clearForm(); }}>
                                        Clear
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default AMS360SetupsCreate;